import { Image } from 'react-native';

import { Images as foundationImages } from '@vfgroup-oneplatform/foundation/Components/Themes';

const Images = {
  chevronRightRed: foundationImages.ic_chevron_right_red,
  // Ebill
  background: Image.resolveAssetSource(require('./../Images/Background/app_bg.png')),
  chargeToBillDark: Image.resolveAssetSource(require('./../Images/Icons/chargeToBillDark.png')),
  downloadDark: Image.resolveAssetSource(require('./../Images/Icons/downloadDark.png')),
  tvDark: Image.resolveAssetSource(require('./../Images/Icons/tvDark.png')),
  mobileDark: Image.resolveAssetSource(require('./../Images/Icons/mobileDark.png')),
  routerDark: Image.resolveAssetSource(require('./../Images/Icons/routerDark.png')),
  parentalControlDark: Image.resolveAssetSource(
    require('./../Images/Icons/parentalControlDark.png'),
  ),
  icClock: Image.resolveAssetSource(require('./../Images/Icons/icClockHiLightTheme.png')),
  icInfoRed: Image.resolveAssetSource(require('./../Images/Icons/icInfoRed.png')),
  icInfoCircleGrey: Image.resolveAssetSource(require('./../Images/Icons/icInfoCircleGrey.png')),
  ic_green_circle: Image.resolveAssetSource(require('./../Images/Icons/ic_green_circle.png')),
  ic_red_circle: Image.resolveAssetSource(require('./../Images/Icons/ic_red_circle.png')),

  ic_wifi: Image.resolveAssetSource(
    require('./../Images/Icons/ic_wifi_medium.png')
  ),
  roaming: Image.resolveAssetSource(
    require('./../Images/Icons/roaming.png')
  ),
  roaming_white: Image.resolveAssetSource(
    require('./../Images/Icons/roaming_white.png')
  ),
  tv_white: Image.resolveAssetSource(
    require('./../Images/Icons/tv_white.png')
  ),
  mobile_white: Image.resolveAssetSource(
    require('./../Images/Icons/mobile_white.png')
  ),
  wifi_white: Image.resolveAssetSource(
    require('./../Images/Icons/wifi_white.png')
  ),
  router_white: Image.resolveAssetSource(
    require('./../Images/Icons/router_white.png')
  ),
};

export default Images;
